import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Products from "./pages/Products.js";
import Header from "./pages/Header.js";
import HeroSection from "./pages/HeroContainer.js";
import "./pages/Styles.css";
import Footer from "./pages/Footer.js";
import Vision from "./pages/Vision.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Companion from "./pages/Companion.js";
import GupsyPage from "./pages/Gupsy.js";
import Faq from "./pages/Faq.js";
import HowItWorks from "./pages/Products.js";
import Technology from "./pages/Technology.js";
import ReachUs from "./pages/Reachus.js";
import Layout from "./pages/Layout.js";
import AnalyticsSection from "./pages/AnalyticsSection.js";
import NotFound from "./pages/NotFound";
import UpcomingProducts from "./pages/Upcoming.js";
import AboutUsPage from "./pages/Aboutus.js";

function LandingPage() {
  const aboutRef = useRef(null);
  const getInTouchRef = useRef(null);
  const contactRef = useRef(null);
  const memoryRef = useRef(null);

  return (
    <>
      <Helmet>
        <title>Neomonks Tech Pvt Ltd</title>
        <meta
          name="description"
          content="Neomonks is a technology company dedicated to building AI products that make life simpler, smarter, and more meaningful. Explore our innovative solutions and join us on our mission to transform the future with AI."
        />
        <link rel="canonical" href="https://www.gupsy.neomonkstech.com/" />
      </Helmet>

      <div>
        <Header sectionsRef={{ about: aboutRef, getInTouch: getInTouchRef }} />
        <HeroSection />
        <AnalyticsSection />
        <Vision ref={aboutRef} />
        <Companion />
        {/* <GupsyPage /> */}
        {/*<HowItWorks ref={memoryRef} />
        <Faq />
        <Gallery />*/}
        <Footer
          sectionsRef={{
            about: aboutRef,
            getInTouch: getInTouchRef,
            memory: memoryRef,
          }}
        />
      </div>
    </>
  );
}

function ReachUsPage() {
  return (
    <>
      {/* SEO for /reach-us */}
      <Helmet>
        <title>Neomonks - Contact Us</title>
        <meta
          name="description"
          content="Have questions about Neomonks, partnerships, or support? Reach out to the Neomonks team through our contact page."
        />
        <link
          rel="canonical"
          href="https://www.gupsy.neomonkstech.com/reach-us"
        />
      </Helmet>

      <ReachUs />
    </>
  );
}

function NotFoundPage() {
  return (
    <>
      {/* 404 pages should generally NOT be indexed */}
      <Helmet>
        <title>Page Not Found – Neomonks</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <NotFound />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        {/* <Layout> */}
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route path="/products" element={<Products />} />
          <Route path="/products/gupsy" element={<GupsyPage />} />
          <Route path="/products/upcoming" element={<UpcomingProducts />} />

          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/technology" element={<Technology />} />

          <Route path="/reach-us" element={<ReachUsPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
